import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import Vector from '../../assets/images/Vector232.svg'
import ahmedAli from '../../assets/images/ahmed_ali.jpg'
import ahmedAli2 from '../../assets/images/ahmed_ali2.jpg'
import { Carousel } from '../Carousel';
import { SwiperSlide } from "swiper/react";
import { Rate } from 'antd'



const SliderContainer = styled.div`
  width: 100%;
  height: 55vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #012F6B;
  position: relative;
  z-index: -1;
`
const VectorStyled = styled.div`
position:absolute;
    width: 535.91px;
    height: 273px;
    ${({ left }) => left && `left: ${left};`}
    ${({ bottom }) => bottom && `bottom: ${bottom};`}
    ${({ right }) => right && `right: ${right};`}
    ${({ top }) => top && `top: ${top};`}
    background: url(${Vector}) no-repeat center;
    ${({ rotate }) => rotate && `transform: rotate(${rotate}deg);`}
    z-index: 1;
`;

const CardContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;

    }
`;

const data = [
    {
        id: 1,
        name: 'Ali Ahmed',
        description: '“Vestibulum, cum nam non amet consectetur morbi aenean condimentum eget. Ultricies integer nunc neque accumsan laoreet. Viverra nibh ultrices.”',
        rate: 5,
        image: ahmedAli

    },
    {
        id: 2,
        name: 'Ali Ahmed',
        description: '“Vestibulum, cum nam non amet consectetur morbi aenean condimentum eget. Ultricies integer nunc neque accumsan laoreet. Viverra nibh ultrices.”',
        rate: 5,
        image: ahmedAli2

    },

]

const TestimonialCard = ({ name, rate, image, description }) => (
    <CardContainer >
        <div>
            <img src={image} alt="" />
        </div>
        <div style={{ margin: '0 2rem' }}>
            <p style={{
                fontSize: '16px',
                fontWeight: '400',
                color: '#fff',
                lineHeight: '24px',
            }}>{description}</p>
            <h3 style={{
                fontSize: '24px',
                fontWeight: '500',
                color: '#fff',
                lineHeight: '36px',

            }}>{name}</h3>
            <Rate disabled value={5} />
        </div>
    </CardContainer>
)


const Testimonial = () => {
    const [carouselData, setCarouselData] = useState([])

    useEffect(() => {
        setCarouselData(data)
    }, []);

    return (

        <SliderContainer>
            <VectorStyled left="0" bottom="0" />
            <VectorStyled right="0" top="0" rotate="180" />
            <Carousel data={carouselData}>
                {carouselData.map(({ id, name, description, rate, image }) => (
                    <SwiperSlide>
                        <TestimonialCard id name={name} description={description} rate={rate} image={image} />
                    </SwiperSlide>
                ))}

            </Carousel>
        </SliderContainer>


    )
}

export default Testimonial